module.exports = __webpack_public_path__ + "img/green-stars.6b3d42ea.svg";